export function closeGetRegulationCategoriesFetch() {
    return {
        type: 'API_GET_REGULATION_CATEGORIES_CLOSE_FETCH',
    }
}

export function closeCreateRegulationCategoryFetch() {
    return {
        type: 'API_CREATE_REGULATION_CATEGORY_CLOSE_FETCH',
    }
}

export function closeUpdateRegulationCategoryFetch() {
    return {
        type: 'API_UPDATE_REGULATION_CATEGORY_CLOSE_FETCH',
    }
}

export function closeDeleteRegulationCategoryFetch() {
    return {
        type: 'API_DELETE_REGULATION_CATEGORY_CLOSE_FETCH',
    }
}

export function getRegulationCategories() {
    return {
        type: 'API_GET_REGULATION_CATEGORIES',
        payload: {
            request: {
                method: 'GET',
                url: '/regulation_categories'
            }
        }
    }
}

export function createRegulationCategory(regulation_category) {
    return {
        type: 'API_CREATE_REGULATION_CATEGORY',
        payload: {
            request: {
                method: 'POST',
                url: `/regulation_categories`,
                data: regulation_category,
            }
        }
    }
}

export function updateRegulationCategory(regulation_category) {
    return {
        type: 'API_UPDATE_REGULATION_CATEGORY',
        payload: {
            request: {
                method: 'PUT',
                url: `/regulation_categories/${regulation_category.id}`,
                data: regulation_category,
            }
        }
    }
}

export function deleteRegulationCategory(regulation_category) {
    return {
        type: 'API_DELETE_REGULATION_CATEGORY',
        payload: {
            request: {
                method: 'DELETE',
                url: `/regulation_categories/${regulation_category.id}`,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/regulation_categories.js